import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector } from "@mui/x-data-grid";

function CustomPagination({ totalFetch, rowsPerPage, theRowsInPageChangedByHeader }) {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCountDefault = useGridSelector(apiRef, gridPageCountSelector);

  function handlePageCount() {
    if (totalFetch && (theRowsInPageChangedByHeader || rowsPerPage)) {
      return Math.ceil(totalFetch / (theRowsInPageChangedByHeader || rowsPerPage));
    } else {
      return pageCountDefault;
    }
  }

  return (
    <Pagination
      color="primary"
      variant="outlined"
      shape="rounded"
      defaultPage={rowsPerPage}
      page={page + 1}
      count={handlePageCount()}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}
export default CustomPagination;
